import React from "react";
import * as styles from "./NestedContentTeaser.module.less";
import { StructuredTextRenderer } from "../../../components/StructuredTextRenderer";
import { TeaserLayoutWrapper } from "../../../components/teaser-components/TeaserLayoutWrapper/TeaserLayoutWrapper";
import { generateClassString as gcs } from "../../../lib/helper/generateClassString";
import { TeaserGrid } from "../../../components/teaser-components/TeaserGrid/TeaserGrid";

export function NestedContentTeaser(props) {
    const {
        tagline,
        headline,
        semanticOfHeadline,
        teaser,
        link,
        hasLightBackground = true
    } = props;

    const teaserList = teaser.map(
        ({ contentTeaserLink, contentTeaserText, ...otherTeaserProps }) => {
            let result = { ...otherTeaserProps };

            if (contentTeaserLink) {
                result = { ...result, teaserLink: contentTeaserLink };
            }

            if (contentTeaserText) {
                result = { ...result, teaserText: contentTeaserText };
            }

            return result
        }
    );

    return (
        <div className={gcs(styles.teaserContainer, "nestedContentTeaser")}>
            <TeaserLayoutWrapper
                tagline={tagline}
                headline={headline}
                semanticOfHeadline={semanticOfHeadline}
                sectionClass={styles.mediaTextAdvancedTeaserLayout}
            >
                <TeaserGrid
                    teaserList={teaserList}
                    sliderOnMobile={true}
                    hasLightBackground={!hasLightBackground}
                />
            </TeaserLayoutWrapper>
            <StructuredTextRenderer
                data={link}
                itemLinkType="cta"
                plainLink
                noContainer
                contentElementType={"NestedContentTeaser"}
            />
        </div>
    );
}
